import { defaultLocale } from '@/constants/locale';
import { routes } from '@/constants/routes';

/**
 * Route names served under `/:lang/*` in App.tsx. A URL whose first segment is
 * one of these simply forgot its language prefix.
 */
const LAYOUT_ROUTES = new Set([
  ...Object.values(routes).map(route => route.replace(/^\//, '')),
  'two-factor-authentication',
  'sso-callback',
]);

/**
 * Rewrites a URL whose first path segment is not a supported language.
 *
 * - `/sign-in?x=1`      -> `/en/sign-in?x=1`   (prefix missing, keep the route)
 * - `/en-GB/sign-up?x`  -> `/en/sign-up?x`     (unsupported locale, swap it)
 * - `/what-ever/`       -> `/en/`               (unknown segment, drop it)
 *
 * Before this existed the layout stripped the first segment in every case, so
 * `/sign-in` became `/en` and the landing page loader (PDE-914).
 */
export const getLocalizedPath = (pathname: string, search: string): string => {
  const [, firstSegment = '', ...rest] = pathname.split('/');

  const localizedPath = LAYOUT_ROUTES.has(firstSegment)
    ? pathname
    : `/${rest.join('/')}`;

  return `/${defaultLocale}${localizedPath === '/' ? '' : localizedPath}${search}`;
};
